// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#learner-table[data-v-74f9d932]{width:100%;padding:0 36px}.bulb-title-cell[data-v-74f9d932]{width:100%;height:100%;display:flex;justify-content:left;align-items:center}.full-width[data-v-74f9d932]{width:100%}", ""]);
// Exports
module.exports = exports;
